import { Component, OnInit, Input } from '@angular/core';
import { PrescriptionPopupComponent } from './prescription-popup.component';
import { DialogService } from '../../../shared/services/dialog.service';
import { ConsultationHistoryService } from '../consultation-history.service';
import { SharedService } from '../../../shared/services/share.services';
import { AppConstants } from '../../../shared/constants/constants';
import { MdCheckboxChange } from '@angular/material';

@Component({
    selector: 'ch-prescription',
    templateUrl: 'prescription.component.html',
    providers: [ConsultationHistoryService, SharedService]
})

export class PrescriptionComponent implements OnInit {
    @Input() history = false;
    public klass = 'consultationhistory';
    public selectedPresciptions: string;
    @Input() prescription: any;
    @Input() patientId: string;
    @Input() consultationHistoryId: string;
    @Input() height: number;
    public presToPrint = [];
    constructor(public dialog: DialogService,
        public consultationHistoryService: ConsultationHistoryService,
        public shareServices: SharedService
    ) { }

    ngOnInit() {
        this.height = this.height ? (this.height > 600 ? this.height - 172 : this.height - 185) : null;
    }

    openPrescription(prescription: any) {
        const height = window.screen.height - (window.screen.height * 30 / 100);
        const data = {
            patientId: this.patientId,
            consultationHistoryId: this.consultationHistoryId,
            height: height
        };
        this.dialog.openComponentDialog(PrescriptionPopupComponent, data, { width: '80%', height: height + 'px' }).subscribe(result => {
            if (result) {
                this.consultationHistoryService.getPrescription(data.consultationHistoryId).subscribe(callback => {
                    if (callback) {
                        const dataCallback = callback.json();
                        this.prescription = dataCallback;
                    }
                });
            }
        });
    }

    filterChecked(id) {
        const index = this.presToPrint.findIndex(x => x === id);
        if (index < 0) {
            this.presToPrint.push(id);
        } else {
            this.presToPrint.splice(index, 1);
        }
        this.selectedPresciptions = this.presToPrint.toString();
    }

    changeCheckbox(event: MdCheckboxChange) {
        if (event) {
            this.filterChecked(event.source.value);
        }
    }

    printAll() {
        const params = {            
            [AppConstants.reportParameter.historyId]: this.consultationHistoryId,
            [AppConstants.reportParameter.pdfprintType]: 'pdf'
        };
        // call api show report all
        this.shareServices.showReport('Prescription', params);
    }

    printIndividual() {
        // call api show report individual
        const params = {
            [AppConstants.reportParameter.historyId]: this.consultationHistoryId,
            [AppConstants.reportParameter.scriptIds]: this.selectedPresciptions,
            [AppConstants.reportParameter.pdfprintType]: 'pdf'
        };
        // call api show report all
        this.shareServices.showReport('Prescription', params);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/prescription/prescription.component.ts